function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.42344 8.07686L1.06094 2.71436C0.863603 2.51004 0.754409 2.23638 0.756877 1.95234C0.759345 1.66829 0.873278 1.39658 1.07414 1.19572C1.275 0.99486 1.54671 0.880927 1.83076 0.878459C2.1148 0.875991 2.38845 0.985185 2.59277 1.18252L8.72119 7.31094C8.92428 7.51409 9.03838 7.78959 9.03838 8.07686C9.03838 8.36412 8.92428 8.63962 8.72119 8.84277L2.59277 14.9712C2.38845 15.1685 2.1148 15.2777 1.83076 15.2753C1.54671 15.2728 1.275 15.1588 1.07414 14.958C0.873278 14.7571 0.759345 14.4854 0.756877 14.2014C0.754409 13.9173 0.863603 13.6437 1.06094 13.4394L6.42344 8.07686Z",
  fill: "black"
});

function SvgIcDateAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateAsc);
export default ForwardRef;